// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.access-restriction-table th[data-v-553cd4f3],\n.access-restriction-table td[data-v-553cd4f3] {\n  vertical-align: middle;\n  text-align: center;\n}\n.access-day[data-v-553cd4f3] {\n  font-weight: bold;\n  text-align: left;\n}\n.access-time-green[data-v-553cd4f3] {\n  background-color: #218838 !important;\n  color: #fff;\n}\n.access-time-red[data-v-553cd4f3] {\n  background-color: #dc3545 !important;\n  color: #fff;\n}\n.vc-time-picker .vc-date {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
